export enum SizeUnits {
  Bytes = 'б',
  KB = 'Кб',
  MB = 'Мб',
  GB = 'Гб',
  TB = 'Tб',
  PB = 'Пб',
}

export const convertFileSize = (bytes: number, sizeUnits: SizeUnits, decimals = 2): number => {
  const dm = decimals < 0 ? 0 : decimals;
  const i = Object.values(SizeUnits).indexOf(sizeUnits);
  const sizeUnitsBytes = Math.pow(1024, i);
  return Number((bytes / sizeUnitsBytes).toFixed(dm));
};
